import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["space", "align"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Stack/Stack.js",
    _this = this;

import React from 'react';
import styled from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { testIdProps } from '../../helpers';

var Stack = function Stack(_ref) {
  var space = _ref.space,
      align = _ref.align,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StackContainer, _extends({}, testIdProps(rest), rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }), React.Children.map(rest.children, function (child) {
    return /*#__PURE__*/React.createElement(StackChild, {
      space: space,
      align: align,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 11,
        columnNumber: 9
      }
    }, child);
  }));
};

Stack.defaultProps = {
  space: 1
};
export default Stack;
var StackContainer = styled.div.withConfig({
  displayName: "Stack__StackContainer",
  componentId: "sc-1r6b4dt-0"
})(["display:block;"]);
var StackChild = withTheme(styled.div.withConfig({
  displayName: "Stack__StackChild",
  componentId: "sc-1r6b4dt-1"
})(["display:flex;flex-direction:column;", " &:not(:last-child){margin-bottom:", "px;}"], function (p) {
  return p.align !== 'none' && "align-items: ".concat(alignFlexStyles[p.align], ";");
}, function (p) {
  return p.space * 8;
}));
var alignFlexStyles = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};